

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import config from '@/config/index'
import ico1 from '@/assets/yz/yzHome-01.png'
import ico2 from '@/assets/yz/yzHome-02.png'
import ico3 from '@/assets/yz/yzHome-03.png'
import ico4 from '@/assets/yz/yzHome-04.png'
import ico5 from '@/assets/yz/yzHome-05.png'
import ico6 from '@/assets/yz/yzHome-06.png'
import ico7 from '@/assets/yz/yzHome-09.png'
import ico8 from '@/assets/yz/yzHome-08.png'
import ico9 from '@/assets/ico-qz.png'
import ico10 from '@/assets/ico-dzsw.png'
import icoygl from '@/assets/ico-ygl.png'
import icoygx from '@/assets/ico-ygx.png'
import icoygb from '@/assets/ico-ygb.png'
import icoygh from '@/assets/ico-ygh.png'
import footnav from '@/views/components/footnav'
import icoEmail from '@/assets/ico-menu-ghfw1.png'
import icoLaw from '@/assets/ico-menu-ghfw2.png'
import pintuan from '@/assets/yz/icon-pintuan.png'
import pengcheng from '@/assets/yz/pengcheng.png'
import zhigongxiaojia from '@/assets/yz/zhigongxiaojia.png'
import yiliaohuzhu from '@/assets/yz/yiliaohuzhu.png'
import zhibo from '@/assets/yz/zhibo.png'
import bianming from '@/assets/yz/yzHome-07.png'
import xmly from '@/assets/yz/icon-xmly.png'
import ygsw from '@/assets/icon_yougongshuwu.png'
import weiyitong from '@/assets/icon_weiyitong.png'
import ygq from '@/assets/icon-ygq.png'
import icoYizhen from '@/assets/icon_xianshangyizhen.png'
import icoPfwjt from '@/assets/ico-pfwjt.png'
import icoMmxw from '@/assets/ico-mmxw.png'
import hgsc from '@/assets/ico-hgsc.png'
import { getNewslist, getNewslistAll, getMd5Openid } from '@/api/youzheng'
import { getlist, getaddlog } from '@/api/hgfw'
import { operateCreditlist } from '@/api/user'
import { getRequest } from '@/libs/utils.js'
import md5 from 'vux/src/tools/md5/index.js'

export default {
name: 'home',
data () {
return {
ygsw: ygsw,
md5: '',
quickshow: 0,
baseUrl: config.baseUrl,
bannerlist: [],
piclist: [],
newslists: [],
pageSize: 10,
isOpen: false,
ico9: ico9,
ico10: ico10,
menulist: [
{
name: '签到',
url: ico1,
wlink: false,
href: { name: 'mysign' }
},
{
name: '朋橙心理',
url: pengcheng,
wlink: false,
href: { name: 'pengchengxinli' }
},
{
name: '邮工圈',
url: ygq,
wlink: false,
href: { name: 'yuangongquan' }
},
{
name: '惠工商城',
url: hgsc,
wlink: false,
href: ''
},












{
name: '微医通',
url: weiyitong,
wlink: false,
href: { name: 'xiqueClinc' }
},
{
name: '主席信箱',
url: icoEmail,
wlink: false,
href: ''
},
{
name: '积分商城',
url: ico3,
wlink: false,
href: { name: 'mall2Index' }
},
{
name: '嘉年华',
url: ico4,
wlink: false,
href: { name: 'jianianhuaindex' }
}
],
menulist2: [
{
name: '惠工服务',
url: ico2,
wlink: false,
href: { name: 'hgfw' }
},
{
name: '浙工书屋',
url: ico5,
wlink: true,
href: 'https://www.dzzgsw.com/index3.html'
},
{
name: '邮文化',
url: ico7,
wlink: false,
href: { name: 'youwenhua', params: { selected: 0, category: 'cat10_01' } }
},
{
name: '便民服务',
url: bianming,
wlink: false,
href: { name: 'ser-bmfw' }
},
{
name: '喜马拉雅',
url: xmly,
wlink: true,
href: 'http://open.ximalaya.com/site/index/282/a012835802b3317309c0adda4e6f7f9e'
},
{
name: '职工小家',
url: zhigongxiaojia,
wlink: false,
href: { name: 'zhigongxiaojia' }
},
{
name: '法律服务',
url: icoLaw,
wlink: false,
href: this.$store.state.user.personObj.accounttype === 4 ? { name: 'mylawyerAsk' } : { name: 'lawyerIndex' }
}
],
menulist3: [
{
name: '拼团活动',
url: pintuan,
wlink: false,
href: { name: 'pintuan' }
},
{
name: '普法微讲堂',
url: icoPfwjt,
wlink: false,
href: { name: 'pufaweijiangtang' }
},
{
name: '医疗互助',
url: yiliaohuzhu,
wlink: false,
href: { name: 'yiliaohuzhu' }
},
{
name: '妈咪小屋',
url: icoMmxw,
wlink: false,
href: { name: 'mamixiaowu' }
},
{
name: '直播',
url: zhibo,
wlink: false,
href: { name: 'zhiboIndex' }
}
],
quicklist: [],
yglist: [{
img: icoygl,
url: '/yougongle'
}, {
img: icoygx,
url: '/zgsw'
}, {
img: icoygb,
url: '/yougongbang'
}, {
img: icoygh,
url: '/yougonghui'
}],
accounttype: this.$store.state.user.personObj.accounttype,
isqyb: this.$store.state.user.personObj.isqyb,
mobile: this.$store.state.user.personObj.mobile
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
created () {
this.getAdd()
this.list()
this.getQuicklist()
this.getpiclist()

this.addCredit()
this.link()
},
components: {
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
footnav
},
mounted () {
},
methods: {





























linkWeapp () {
console.log(32)
this.$router.push({ name: 'weiyitong' })
},
link () {
getMd5Openid({
userid: this.userid
}).then(res => {
console.log(res.returnValue.md5)
this.md5 = res.returnValue.md5





})
},
getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120101
}).then(res => {
})
},
getQuicklist () {
getNewslist({
pageCurrent: 1,
pageSize: 3,
CATEGORYCODE: 'cat01_01',
owner_type: config.owner_type,
searchValue: ''
}).then(res => {
this.quicklist = res.obj
setInterval(() => {
this.quickshow++
if (this.quickshow >= this.quicklist.length) {
this.quickshow = 0
}
}, 5000)
})
},
getpiclist () {
this.piclist = []

getNewslist({
CATEGORYCODES: 'cat02_01,cat03_01,cat04_01,cat08_01,cat09_01',
searchValue: '',
pageSize: 5,
pageCurrent: 1,
owner_type: this.$config.owner_type,
CONTENTTYPEID: 4
}).then(data => {
data.obj.forEach((item, i) => {
this.piclist.push({
imgurl: item.mobileTitleImgURL,
title: item.TITLE,
id: item.ID
})
})
})
},
newslist () {
getNewslistAll({
CATEGORYCODES: 'cat02_01,cat03_01,cat04_01,cat05_01,cat05_02,cat08_01',
rows: 4,
page: 1,
owner_type: this.$config.owner_type
}).then(data => {
this.newslists = data.rows
})
},
linkdetail (link) {
window.location.href = link
},
detail (ID) {
this.$router.push({ name: 'yzDetail', params: { type: ID } })
},
goto (href, wlink, index) {
if (wlink) {
window.location.href = href
} else {
if (index == 2) {

this.$vux.alert.show({
title: '提示',
content: '各位会员，因系统原因，邮工圈功能将于3月16日0时起进行改造升级，开放时间另行通知。给您带来的不便敬请谅解。',
onShow () { },
onHide () { }
})
} else if (index == 3) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'hgsc',
owner_type: this.$config.owner_type
}).then(res => { })
let temp = 'appKey=20210813114859096&outerMemberId=' + encodeURIComponent(this.userid) + '&phone=' + this.mobile + '&targetURL=1001&tenant=youzhenggonghuiiz6hk3EQ1D2xEgAw'
let a = md5(temp.toLowerCase())
let alink = 'https://emallh5.namek.com.cn/emall/pages/auth/thirdPageIn?tenant=youzhenggonghui&appKey=20210813114859096&targetURL=1001&isMiniProgram=1&phone=' + this.mobile + '&outerMemberId=' + encodeURIComponent(this.userid) + '&sign=' + a

window.location.href = alink
} else if (index == 4) {
this.linkWeapp()
} else if (index == 5) {
if (this.accounttype === 0 || this.accounttype === 1 || (this.isqyb === 2 && this.accounttype === 3 || this.accounttype === 4)) {
this.$router.push({ name: 'declare' })
} else if (this.accounttype === 2 || this.accounttype === 3) {
this.$router.push({ name: 'myMailWorkdeclare', params: { selected: 0 } })
}
} else {
this.$router.push(href)
}
}
},
goto2 (href, wlink, index) {
if (wlink) {
window.location.href = href
} else {
this.$router.push(href)
}
},
addCredit () {
/* 添加积分 */
if (this.accountid !== '' && this.accountid != null) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'rule_001',
owner_type: this.$config.owner_type,

terminaltype: 2
}).then(res => {
let shareid = getRequest().shareid
if (res.status === 'suc' && shareid) { // 从分享进入当前页面
operateCreditlist({
accountid: shareid,
rulecode: 'share',
owner_type: this.$config.owner_type,

terminaltype: 2
}).then(res => { })
}
})
}
},

list () {
getlist({ phtype: 4 }).then(res => {
if (res.status != 'error') {
let bannerlist = []
let temp = 'appKey=20210813114859096&outerMemberId=' + encodeURIComponent(this.userid) + '&phone=' + this.mobile + '&targetURL=1001&tenant=youzhenggonghuiiz6hk3EQ1D2xEgAw'
let a = md5(temp.toLowerCase())
let alink = 'https://emallh5.namek.com.cn/emall/pages/auth/thirdPageIn?tenant=youzhenggonghui&appKey=20210813114859096&targetURL=1001&isMiniProgram=1&phone=' + this.mobile + '&outerMemberId=' + encodeURIComponent(this.userid) + '&sign=' + a
res.returnValue.rows.map((val, index, arr) => {
let list = {
url: index!==0 ? val.link : alink,
img: this.baseUrl + val.picpath
}
bannerlist.push(list)
})
this.bannerlist = bannerlist
}
})
},
more () {
this.$router.push({ name: 'news' })
}
}
}
